import I18n from 'i18n-js';
import React from 'react';
import classNames from 'classnames';
import { buttonClassName } from '@reverbdotcom/cadence/components';

interface Props {
  title: string;
  href: string;
  backgroundImage: string;
  narrow?: boolean;
}

export default function CalloutEmbed(props: Props) {
  const classes = classNames(
    'callout-embed',
    { 'callout-embed--narrow': props.narrow },
  );

  return (
    <div
      className={classes}
      style={{ backgroundImage: `url(${props.backgroundImage})` }}
    >
      <a href={props.href}>
        <h1 className="callout-embed__title">
          {props.title}
        </h1>
        <span className={buttonClassName({ variant: 'light' })}>
          {I18n.t('discovery.calloutEmbed.shopNow')}
        </span>
      </a>
    </div>
  );
}
